export { isRuntimeCompatible } from '@qiankunjs/shared';
